var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.charts),function(chart){return [_c('Chart',{key:chart.id,staticClass:"mb-2",attrs:{"type":chart.type,"chart":chart,"delete-chart":() => 1},on:{"delete":function($event){return _vm.$emit('delete', chart.id)},"show-form":function($event){return _vm.$emit('show-form', chart.id)}}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }